/* eslint-disable @typescript-eslint/no-unused-vars */
import { DatePicker, Input, message, Modal, Spin, Form, Upload, Tooltip, Button as AntdButton, ConfigProvider } from "antd";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { TranslateString, convertToObjectKeyString, downloadBlob } from "Utils/Common";
import SingleLoanViewOne from "./SingleLoanViewOne";
import SingleLoanViewTwo from "./SingleLoanViewTwo";
import SingleLoanViewThree from "./SingleLoanViewThree";
import SingleLoanServices from "services/services/SingleLoanServices";
import moment from "moment";
import UserService from "services/UserService";
import TenderServices from "services/services/TenderServices";
import { Button } from "react-bootstrap";
import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { useIntl } from "react-intl";
import localeFI from "antd/lib/locale/fi_FI";
import localeEN from "antd/lib/locale/en_US";
import 'moment/locale/fi';
import { CloudFileBasePath } from 'constants/Constants';
import { useParams } from 'react-router';
const REACT_APP_URL = process.env.REACT_APP_URL;


const SingleLoanViewLayout = (props: any) => {
    const intl = useIntl();
    const userRole = UserService?.hasRole(['app-moderator']);
    const targetRef: any = useRef();
    const [loading, setLoading] = useState<boolean>(false);
    const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
    const [btnLoading, setBtnLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [openV2, setOpenV2] = useState<boolean>(false);
    const [btnOpen, setBtnOpen] = useState<boolean>(false);
    const [btnState, setBtnState] = useState<any>();
    const [loanData, setLoanData] = useState<any>();
    const [saveData, setSaveData] = useState<any>();
    const [fileData, setFileData] = useState<any>();
    const [bankList, setBankList] = useState<any>();
    const [changeDeadline, setChangeDeadline] = useState<any>(true);
    const [offerList, setOfferList] = useState<any>();
    const [rejectValue, setRejectValue] = useState<any>();
    const [acceptValue, setAcceptValue] = useState<any>();
    const [dimensions, setDimensions] = useState({ height: 0 });
    const [filesCheck, setFilesCheck] = useState({ ador_analysis: true, share_analysis: true, property_certificate: false, accounting_data: false, energy_certificate: false, additional_attachment: false, contract: true });
    const [uploadedFileList, setUploadedFileList] = useState<any>([]);
    const [adorContract, setAdorContract] = useState<any>("");
    const [marketingMaterials, setMarketingMaterials] = useState<any>("");
    const params =  useParams();

    useLayoutEffect(() => {
        if (targetRef.current) {
            setDimensions({
                height: targetRef.current.offsetHeight
            });
        }
    }, [props]);

    useEffect(()=>{
// console.log(bankList?.length,"====bankList?.length")
        if(bankList?.length){
            let bank_ids = bankList?.flat()?.filter((val: any) => val.bank_id !== "select_all")
            if (bank_ids.some((val: any) => val.checked)) {
                setChangeDeadline(false);
            }else{
                setChangeDeadline(true);
            }
        }
    },[bankList])
// console.log(changeDeadline,"====changeDeadline")

    useEffect(() => {
        getLoanData();
        getSettingsData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const downloadBlobFile = async (docId:any) => {
        setLoading(true);
        await downloadBlob(docId);
        setLoading(false);
    }

    useEffect(() => {
        if(userRole){
            getLoanData();
            props?.setSendHRrequest(false);
        }
    }, [props?.sendHRrequest]);

    const getAllOffers = (id: any) => {
        let obj: any = {}
        obj.loan_credit_id = id;
        obj.tender_id = params?.loan_tender_id;

        setLoading(true);
        SingleLoanServices
            .getAllOffers(obj)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseVal = response?.data?.data
                    setOfferList(responseVal)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    const getLoanData = () => {
        setLoading(true);

        let paramsId = props.loan_tender_id

        SingleLoanServices
            .getSingleLoanData(paramsId)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseVal = response?.data?.data
                    getBankData(responseVal?.LOAN_DATA?.CUST_DATA?.cust_data_city);
                    if (userRole) props?.setDisableBtn(responseVal?.loan_tender_status === "end_tender" ? true : false)
                    getAllOffers(responseVal?.LOAN_DATA?.loan_data_credit_id)
                    setLoanData(responseVal)
                    setSaveData({ ...saveData, loan_tender_id: paramsId, loan_credit_id: responseVal?.LOAN_DATA?.loan_data_credit_id, attachment_ids: responseVal?.LOAN_DATA?.LOAN_DOC, loan_data_id: responseVal?.LOAN_DATA?.loan_data_id, loan_data_name: responseVal.loan_data_name, loan_data_customerid: responseVal?.LOAN_DATA?.loan_data_customerid, loan_data_customername: responseVal?.LOAN_DATA?.loan_data_customername, tender_req_deadline: moment().add(14, 'days') })
                    setFileData(({ customerid: responseVal?.LOAN_DATA?.loan_data_customerid, creditid: responseVal?.LOAN_DATA?.loan_data_credit_id, loan_tender_id: paramsId, loanname: responseVal?.loan_data_name }))
                    if (response?.data?.data?.LOAN_DATA?.LOAN_DOC) {
                        let tenderList:any = response?.data?.data?.LOAN_DATA?.LOAN_DOC?.filter((val:any)=>val?.loan_status_doc_type === "contract");
                        if (tenderList?.length > 0) {
                            tenderList = tenderList?.map(function (element: any, index: any) {
                                element.name = element.loan_original_filename;
                                element.url = element.loan_status_id;
                                return element;
                            });
                        }
                        setUploadedFileList(tenderList)
                    }
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    };

    function splitArray(array: any, part: any) {
        var tmp = [];
        for (var i = 0; i < array.length; i += part) {
            tmp.push(array.slice(i, i + part));
        }
        return tmp;
    }

    const getBankData = (val: any) => {
        let obj: any = {};
        obj.city_name = val;

        setLoading(true);

        SingleLoanServices
            .getAllBankFromCity(obj)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    let responseVal = response?.data?.data.map((val: any) => {
                        return (
                            { ...val, checked: false }
                        )
                    });
                    responseVal = responseVal?.filter((item:any) => (item?.bank_email?.length  > 0));
                    responseVal.unshift({ bank_name: "Select all", checked: false, bank_id: "select_all" });
                    const bankData = splitArray(responseVal, 3)
                    setBankList(bankData)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    };

    const onNotesChange = (event: any) => {
        setSaveData({ ...saveData, tender_req_notes: event.target.value })
    }

    const handleOk = () => {
        let bank_ids = bankList.flat().filter((val: any) => val.bank_id !== "select_all")
        if (!bank_ids.some((val: any) => val.checked)) {
            setOpen(false);
            return message.error(intl.formatMessage({ id: convertToObjectKeyString("please_select_bank") }));
        }
        if (!saveData.tender_req_deadline) {
            setOpen(false);
            return message.error('Please select deadline for quotation');
        }
        if (filesCheck?.accounting_data && !(saveData?.attachment_ids?.filter((val: any) => val?.loan_status_doc_type === "accounting_data")?.length)) {
            setOpen(false);
            return message.error('Please upload Accounting Data');
        }
        if (filesCheck?.additional_attachment && !(saveData?.attachment_ids?.filter((val: any) => val?.loan_status_doc_type === "additional_attachment")?.length)) {
            setOpen(false);
            return message.error('Please upload Additional Attachment');
        }
        if (filesCheck?.energy_certificate && !(saveData?.attachment_ids?.filter((val: any) => val?.loan_status_doc_type === "energy_certificate")?.length)) {
            setOpen(false);
            return message.error('Please upload Energy Certificate');
        }
        if (filesCheck?.property_certificate && !(saveData?.attachment_ids?.filter((val: any) => val?.loan_status_doc_type === "property_certificate")?.length)) {
            setOpen(false);
            return message.error('Please upload Property Certificate');
        }
        let bank_emails:any = [];
        bank_ids.forEach((element:any) => {
            if(element.checked){
                let obj:any = {};
                obj.bank_id = element.bank_id;
                obj.bank_email = element.bank_email.join();
                bank_emails.push(obj);
            }
        })

        bank_ids = bank_ids.filter((val: any) => val.checked).map((val: any) => parseInt(val.bank_id))

        let obj = {
            ...saveData, tender_req_deadline: moment(saveData?.tender_req_deadline).format("YYYY-MM-DD"), bank_ids,bank_emails, attachment_ids: [...saveData?.attachment_ids.map((val: any) => {
                return { name: val?.loan_status_doc_type, id: val?.loan_status_id }
            })]
        }
        obj = {...obj, attachment_ids: obj.attachment_ids.map((attach:any)=>{
            if(attach?.name === "property_certificate" && filesCheck?.property_certificate){
                return attach
            }else if(attach?.name === "accounting_data" && filesCheck?.accounting_data){
                return attach
            }else if(attach?.name === "energy_certificate" && filesCheck?.energy_certificate){
                return attach
            }else if(attach?.name === "additional_attachment" && filesCheck?.additional_attachment){
                return attach
            }else{
                return null
            }
        })}
        delete obj.loan_data_id;
        if (filesCheck?.ador_analysis) {
            obj = {
                ...obj, attachment_ids: [...obj.attachment_ids, {
                    name: REACT_APP_URL + `/generate-pdf/` + props?.id + "/" + saveData?.loan_data_id  + `?showbtn=0`,
                    id: -1
                }]
            }
        }
        if (filesCheck?.share_analysis) {
            obj = {
                ...obj, attachment_ids: [...obj.attachment_ids, {
                    name: REACT_APP_URL +`/list-of-shareholder-pdf/` + props?.id + `?showbtn=0`,
                    id: -2
                }]
            }
        }

        setConfirmLoading(true);
        SingleLoanServices
            .postSingleLoanData({...obj, attachment_ids: obj?.attachment_ids.filter((foo:any)=>foo != null)})
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    getAllOffers(saveData?.loan_credit_id)
                    setSaveData({ ...saveData, bank_ids: [], tender_req_notes: "", tender_req_deadline: moment().add(12, 'days') })
                    let bankReset = bankList
                    bankReset = bankReset.map((val: any) => {
                        return (val.map((bankVal: any) => {
                            return { ...bankVal, checked: false }
                        }))
                    })
                    setOpen(false);
                    setChangeDeadline(true);
                    setBankList(bankReset)
                    getLoanData();
                    setFilesCheck({ ador_analysis: false, share_analysis: false, property_certificate: false, accounting_data: false, energy_certificate: false, additional_attachment: false, contract: false });
                    message.success(intl.formatMessage({ id: convertToObjectKeyString('tender_request_successfully_sent')}));
                }
                setConfirmLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setConfirmLoading(false);
            });
    }
    const handleChangeDeadline = () => {
        // let bank_ids = bankList.flat().filter((val: any) => val.bank_id !== "select_all")
        // if (!bank_ids.some((val: any) => val.checked)) {
        //     setOpen(false);
        //     return message.error(intl.formatMessage({ id: convertToObjectKeyString("please_select_bank") }));
        // }
        if (!saveData.tender_req_deadline) {
            setOpen(false);
            return message.error('Please select deadline for quotation');
        }
        // if (filesCheck?.accounting_data && !(saveData?.attachment_ids?.filter((val: any) => val?.loan_status_doc_type === "accounting_data")?.length)) {
        //     setOpen(false);
        //     return message.error('Please upload Accounting Data');
        // }
        // if (filesCheck?.additional_attachment && !(saveData?.attachment_ids?.filter((val: any) => val?.loan_status_doc_type === "additional_attachment")?.length)) {
        //     setOpen(false);
        //     return message.error('Please upload Additional Attachment');
        // }
        // if (filesCheck?.energy_certificate && !(saveData?.attachment_ids?.filter((val: any) => val?.loan_status_doc_type === "energy_certificate")?.length)) {
        //     setOpen(false);
        //     return message.error('Please upload Energy Certificate');
        // }
        // if (filesCheck?.property_certificate && !(saveData?.attachment_ids?.filter((val: any) => val?.loan_status_doc_type === "property_certificate")?.length)) {
        //     setOpen(false);
        //     return message.error('Please upload Property Certificate');
        // }
        // let bank_emails:any = [];
        // bank_ids.forEach((element:any) => {
        //     if(element.checked){
        //         let obj:any = {};
        //         obj.bank_id = element.bank_id;
        //         obj.bank_email = element.bank_email.join();
        //         bank_emails.push(obj);
        //     }
        // })

        // bank_ids = bank_ids.filter((val: any) => val.checked).map((val: any) => parseInt(val.bank_id))

        let obj = {
            ...saveData, tender_req_deadline: moment(saveData?.tender_req_deadline).format("YYYY-MM-DD")
        }

        setConfirmLoading(true);
        SingleLoanServices
            .postSingleLoanDataDeadline(obj)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    getAllOffers(saveData?.loan_credit_id)
                    setSaveData({ ...saveData, bank_ids: [], tender_req_notes: "", tender_req_deadline: moment().add(12, 'days') })
                    let bankReset = bankList
                    bankReset = bankReset.map((val: any) => {
                        return (val.map((bankVal: any) => {
                            return { ...bankVal, checked: false }
                        }))
                    })
                    setOpenV2(false);
                    setBankList(bankReset)
                    getLoanData();
                    setFilesCheck({ ador_analysis: false, share_analysis: false, property_certificate: false, accounting_data: false, energy_certificate: false, additional_attachment: false, contract: false });
                    message.success(intl.formatMessage({ id: convertToObjectKeyString('deadline_for_quotation_changed_successfully')}));
                }
                setConfirmLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setConfirmLoading(false);
            });
    }

    const handleCancelPop = () => {
        setOpen(false);
    };
    const handleCancelPopV2 = () => {
        setOpenV2(false);
    };

    const onFinishAccept = (value: any) => {
        if(uploadedFileList?.length === 0) {
            setBtnState("accept")
            return message.error(intl.formatMessage({ id: convertToObjectKeyString('please_attach_document')}))
        };
        setBtnLoading(true);
        
        const object = {
            loan_tender_status: "approved_for_tendering",
            customer_id:loanData?.LOAN_DATA?.loan_data_customerid,
            update_by : "housing_manager",
            hm_comment : value?.hm_comment,
        }
        TenderServices
            .updateTender(props.loan_tender_id, object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(intl.formatMessage({ id: convertToObjectKeyString('tender_accepted')}));
                    setBtnState("")
                    setAcceptValue("")
                    getLoanData();

                }
                setBtnLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setBtnLoading(false);
            });
    }

    const onFinishReject = (value: any) => {
        setBtnLoading(true);
        let object: any={};
        object = {
            loan_tender_status: "tendering_rejected",
            customer_id:loanData?.LOAN_DATA?.loan_data_customerid,
            update_by : "housing_manager",
            hm_comment : value?.hm_comment
        }
        if(value?.hm_deadline){
            object.hm_deadline = moment(value?.hm_deadline).format("YYYY-MM-DD");
            object.loan_tender_deadline = moment(value?.hm_deadline).format("YYYY-MM-DD");
        }
        TenderServices
            .updateTender(props.loan_tender_id, object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(intl.formatMessage({ id: convertToObjectKeyString('tender_rejected')}));
                    setBtnState("")
                    setRejectValue("")
                    getLoanData();

                }
                setBtnLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setBtnLoading(false);
            });
    }

    const propsFile: UploadProps = {
        name: 'file',
        action: process.env.REACT_APP_API_URL_TARGET + 'uploadmultiplepdf',
        headers: {
            Authorization: `Bearer ${UserService.getToken()}`
        },
        data: {
            filetype: "contract",
            customerid: loanData?.LOAN_DATA?.loan_data_customerid,
            creditid: loanData?.LOAN_DATA?.loan_data_credit_id,
            loan_tender_id: loanData?.loan_tender_id,
            loanname: loanData?.LOAN_DATA?.loan_data_name,
        },
        onPreview(previewInfo){
            downloadBlobFile(previewInfo?.url)
        },
        onChange(info) {
            if (info?.file?.status === 'uploading') {
                setLoading(true)
                setTimeout(() => {
                    getLoanData();
                    message.success(intl.formatMessage({ id: convertToObjectKeyString("file_uploaded_successfully")}));
                    setLoading(false)
                }, 5000);
            }
            if (info.file.status === 'done') {
                getLoanData()
                setLoading(false)
                message.success(intl.formatMessage({ id: convertToObjectKeyString("file_uploaded_successfully")}));
            }
            if (info.file.status === 'error') {
                setLoading(false)
                message.error(info?.file?.response?.message);
            }
            
        },
        onRemove(info:any){
            let index = uploadedFileList.find((f:any)=>f.url===info?.url);
            uploadedFileList?.splice(index, 1);
            setUploadedFileList(uploadedFileList);

            if(info?.loan_status_id){
                const deleteData:any = {
                    loan_status_doc_status: 0
                }
        
                setConfirmLoading(true);
                SingleLoanServices
                .deleteAttachment(deleteData, info?.loan_status_id)
                .then((response: any) => {
                    if (response?.data?.code === 200) {
                        message.success(intl.formatMessage({ id: convertToObjectKeyString("deleted_successfully") }));
                        getLoanData()
                    }
                    if (response?.data?.code === 500) {
                        message.error(response?.data?.msg);
                    }
                    setConfirmLoading(false);
                })
                .catch((err: any) => {
                    message.error("There was some error");
                    console.log(err)
                    setConfirmLoading(false);
                    setOpen(false)
                });
            }
        },
        locale:{ removeFile: intl.formatMessage({ id: convertToObjectKeyString("removefile")}) },
        multiple: true,
        fileList: uploadedFileList,
    };

    
    function getSettingsData(): any {
        setLoading(true);
        SingleLoanServices
        .getSettingsData()
        .then((response: any) => {
            if (response?.data?.code === 200) {
                let responseData = response?.data?.data;
                if(responseData[0].key === 'ador_contract'){
                    setAdorContract(CloudFileBasePath + responseData[0].value);
                }
                if(responseData[1].key === 'marketing_materials'){
                    setMarketingMaterials(CloudFileBasePath + responseData[1].value);
                }
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    }
   

    return (
        <>
            <Spin spinning={loading}>
                <SingleLoanViewOne
                    {...props}
                    userRole={userRole}
                    loanData={loanData}
                />
                <SingleLoanViewTwo
                    targetRef={targetRef}
                    dimensions={dimensions}
                    bankList={bankList}
                    changeDeadline={changeDeadline}
                    setBankList={setBankList}
                    fileData={fileData}
                    setFileData={setFileData}
                    getLoanData={getLoanData}
                    loanData={loanData}
                    saveData={saveData}
                    setLoading={setLoading}
                    filesCheck={filesCheck}
                    setFilesCheck={setFilesCheck}
                    userRole={userRole}
                    setBtnState={setBtnState}
                    setBtnOpen={setBtnOpen}
                    setSaveData={setSaveData}
                    onNotesChange={onNotesChange}
                    setOpen={setOpen}
                    setOpenV2={setOpenV2}
                    adorContract={adorContract}
                    marketingMaterials={marketingMaterials}
                    downloadBlobFile={downloadBlobFile}
                    {...props}
                />
                {props?.type === 'manager' && <div>
                    <div className="cu-table-bg-lightgreen mt-4">
                        
                            <div className=" d-flex flex-row justify-content-end align-items-center">
                                <button className="btn btn-sm cu-btn-green m-3"
                                    onClick={() => {
                                        setBtnState("reject")
                                        setBtnOpen(true)
                                    }}
                                >{TranslateString('reject')}</button>
                                <button className="btn btn-sm cu-btn-green m-3"
                                    onClick={() => {
                                        setBtnState("accept")
                                        setBtnOpen(true)
                                    }}
                                >{TranslateString('accept')}</button>
                            </div>
                    </div>
                </div>}
                {props?.type !== 'manager' && <SingleLoanViewThree
                    offerList={offerList}
                    loanData={loanData}
                    downloadBlobFile={downloadBlobFile}
                />}
            </Spin>
            <Modal
                title=""
                open={open}
                onOk={handleOk}
                okButtonProps={{ className: 'cu-bg-green rounded' }}
                okText={TranslateString('yes')}
                cancelText={TranslateString('no')}
                cancelButtonProps={{ className: 'cu-bg-green rounded' }}
                confirmLoading={confirmLoading}
                onCancel={handleCancelPop}
            >
                <p className='h5'>{TranslateString('do_you_want_to_send_tender_request')}</p>
            </Modal>
            <Modal
                title=""
                open={openV2}
                onOk={handleChangeDeadline}
                okButtonProps={{ className: 'cu-bg-green rounded' }}
                okText={TranslateString('yes')}
                cancelText={TranslateString('no')}
                cancelButtonProps={{ className: 'cu-bg-green rounded' }}
                confirmLoading={confirmLoading}
                onCancel={handleCancelPopV2}
            >
                <p className='h5'>{TranslateString('do_you_want_to_chane_deadline')}</p>
            </Modal>
            {/* <Modal
                title=""
                open={btnOpen}
                onOk={btnState == "accept" ? handleAccept : handleReject}
                okButtonProps={{ className: 'cu-bg-green rounded' }}
                okText={TranslateString('yes')}
                cancelButtonProps={{ className: 'cu-bg-green rounded' }}
                confirmLoading={btnLoading}
                onCancel={handleCancelBtn}
            >
                <p className='h5'>{`Do you want to ${btnState} this tender?`}</p>
            </Modal> */}
            <Modal title={TranslateString('reject')} open={btnState === "reject" ? true : false} footer={false} destroyOnClose closable={false}>
                <Form
                    requiredMark={false}
                    name={"Reject"}
                    onFinish={onFinishReject}
                    layout="vertical"
                    initialValues={{hm_comment: rejectValue?.hm_comment, hm_deadline: moment(new Date()) }}
                >
                    <ConfigProvider locale={intl.locale === 'en'? localeEN : localeFI}>
                        <Form.Item
                            label={TranslateString('date')}
                            name="hm_deadline"
                        >
                                <DatePicker
                                    format={"DD.MM.YYYY"}
                                    className="w-100"
                                    onChange={(val) => {
                                        setRejectValue({ ...rejectValue, hm_deadline: val })
                                    }}
                                />
                        </Form.Item>
                    </ConfigProvider>

                    <Form.Item className="mb-0"
                        label={TranslateString('add_comment')}
                        name="hm_comment"
                    >
                        <Input.TextArea rows={4} placeholder={TranslateString('maximum_500_charecter')} maxLength={500} onChange={(e) => {
                            setRejectValue({ ...rejectValue, hm_comment: e.target.value })
                            }} />
                    </Form.Item>
                    <div className="d-flex justify-content-end mt-2">
                        <Button type="reset" className="btn btn-sm btn-secondary px-4" onClick={() => { setBtnState("") }}>{TranslateString('cancel')}</Button>
                        &nbsp;
                        <Button type="submit" className="btn btn-sm btn-light px-3 cu-btn-green" disabled={btnLoading}>{btnLoading ? TranslateString("Please Wait") : TranslateString('submit')}</Button>
                    </div>
                </Form>
            </Modal> 
            <Modal title={TranslateString('accept')} open={btnState === "accept" ? true : false} footer={false} destroyOnClose closable={false}>
                <Form
                    requiredMark={false}
                    name={"Accept"}
                    onFinish={onFinishAccept}
                    layout="vertical"
                    initialValues={{hm_comment: acceptValue?.hm_comment }}
                >
                    <Form.Item className="mb-0"
                        label={TranslateString("add_comment")}
                        name="hm_comment"
                    >
                        <Input.TextArea rows={4} placeholder={TranslateString('maximum_500_charecter')} maxLength={500} onChange={(e) => {
                            setAcceptValue({ ...acceptValue, hm_comment: e.target.value })
                            }} />
                    </Form.Item>
                    <Form.Item label={<><span>{TranslateString('attachment')}</span><span className="text-danger">*</span></>} className="w-100" >
                                        <Upload {...propsFile} className="text-dark">
                                            <Tooltip title={TranslateString('upload')}>
                                                <AntdButton className="rounded" icon={<UploadOutlined />}>{TranslateString('upload')}</AntdButton>
                                            </Tooltip>
                                        </Upload>
                                    </Form.Item>
                    <div className="d-flex justify-content-end mt-2">
                        <Button type="reset" className="btn btn-sm btn-secondary px-4" onClick={() => { setBtnState("") }}>{TranslateString('cancel')}</Button>
                        &nbsp;
                        <Button type="submit" className="btn btn-sm btn-light px-3 cu-btn-green" disabled={btnLoading}>{btnLoading ? TranslateString("Please Wait") : TranslateString('submit')}</Button>
                    </div>
                </Form>
            </Modal> 
        </>
    );
};
export default SingleLoanViewLayout;